import { format, formatDistanceToNowStrict } from 'date-fns';
import { de, enUS, pl, cs } from 'date-fns/locale';
import i18n from 'locale';

const getLocaleSet = (lng: string) => {
	switch (lng) {
		case 'cs':
			return cs;
		case 'de':
			return de;
		case 'en':
			return enUS;
		case 'pl':
		default:
			return pl;
	}
};
const getLocale = (lng: string) => {
	switch (lng) {
		case 'cs':
			return 'cs';
		case 'de':
			return 'de-DE';
		case 'en':
			return 'en-US';
		case 'pl':
		default:
			return 'pl-PL';
	}
};

export type DateFormatType =
	| 'full'
	| 'hours'
	| 'dayAndMonth'
	| 'dayMonth'
	| 'namedMonth'
	| 'date'
	| 'time'
	| 'dayAndMonthPlusYear';

export const dateFormat = (_date: Date | string, type: DateFormatType) => {
	try {
		const date = _date instanceof Date ? _date : new Date(_date);

		switch (type) {
			case 'full':
				return format(date, 'Pp', { locale: getLocaleSet(i18n.language) });
			case 'hours':
				return format(date, 'HH:mm', { locale: getLocaleSet(i18n.language) });
			case 'dayAndMonth':
				return format(date, 'd MMMM', { locale: getLocaleSet(i18n.language) });
			case 'dayMonth':
				return format(date, 'dd.MM', { locale: getLocaleSet(i18n.language) });
			case 'dayAndMonthPlusYear':
				return format(date, 'd MMMM yyyy', { locale: getLocaleSet(i18n.language) });
			case 'namedMonth':
				return format(date, 'd MMMM yyyy, HH:mm', { locale: getLocaleSet(i18n.language) });
			case 'date':
				return date.toLocaleDateString(getLocale(i18n.language));
			case 'time':
				return date.toLocaleTimeString(getLocale(i18n.language));
			default:
				return date.toLocaleString(getLocale(i18n.language));
		}
	} catch {
		console.error('invalid date', _date);
		return undefined;
	}
};

export const formatDistanceToNow = (
	date: Date,
	options?: {
		addSuffix?: boolean;
		unit?: 'second' | 'minute' | 'hour' | 'day' | 'month' | 'year';
		roundingMethod?: 'floor' | 'ceil' | 'round';
	}
) => {
	return formatDistanceToNowStrict(date, {
		locale: getLocaleSet(i18n.language),
		...options,
	});
};
